/**
 * Variant media sync for the product gallery. When a buyer picks a variant,
 * that variant's image moves to the front of [data-product-gallery] so the
 * picture matches the selected size and price.
 *
 * Reads:
 *   script[data-variant-media]   — JSON map { variantId: mediaId }.
 *   [data-product-gallery] > [data-media-id] — gallery items.
 *   input[name="id"] in the product form — initial selected variant.
 * Listens for change events from inputs/selects carrying data-variant-id
 * (the variant picker re-renders, so listening is delegated to document).
 */
const mapEl = document.querySelector('script[data-variant-media]');
const gallery = document.querySelector('[data-product-gallery]');

if (mapEl && gallery) {
  let variantMedia = {};
  try {
    variantMedia = JSON.parse(mapEl.textContent);
  } catch {
    variantMedia = {};
  }

  const showVariant = variantId => {
    const mediaId = variantMedia[String(variantId)];
    if (!mediaId) return;
    const item = gallery.querySelector(`[data-media-id="${mediaId}"]`);
    if (!item || item === gallery.firstElementChild) return;
    gallery.prepend(item);
    gallery.scrollTo({ left: 0, behavior: 'instant' });
  };

  document.addEventListener('change', event => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    const variantId = target.dataset.variantId || target.selectedOptions?.[0]?.dataset.variantId;
    if (variantId) showVariant(variantId);
  });

  const initial = document.querySelector('form[action*="/cart/add"] input[name="id"]');
  if (initial?.value) showVariant(initial.value);
}
